import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { StoreConfigurationActions } from '../actions';
import { catchError, map, mergeMap, take } from 'rxjs/operators';
import { StoreConfigurationFacade } from '../facades/store-configuration.facade';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

@Injectable()
export class StoreConfigurationEffects {
  private readonly actions$: Actions = inject(Actions);
  private readonly storeConfigurationFacade: StoreConfigurationFacade = inject(StoreConfigurationFacade);

  readonly retrieveStoreConfiguration$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(StoreConfigurationActions.retrieveStoreConfiguration),
      mergeMap(action =>
        this.storeConfigurationFacade.getStoreConfiguration(action.store).pipe(
          take(1),
          map(configuration => StoreConfigurationActions.retrieveStoreConfigurationSuccess(
            {storeConfiguration: configuration}
          )),
          catchError(err => of(StoreConfigurationActions.retrieveStoreConfigurationFail({error: err})))
        )
      ),
    );
  });
}
